import React from 'react'
import {createUseStyles} from 'react-jss'
import HubspotForm from 'react-hubspot-form'

import Layout from '../components/layouts/layout'
import BasicPageHeading from '../components/basic-page-heading'

const useStyles = createUseStyles({
  hubspotForm: {
    maxWidth: '80%',
    margin: '2rem auto 0',
  },
})

export default () => {
  const classes = useStyles()

  return (
    <Layout
      title='Contact'
      description='Get in touch with customer support or sales to answer questions about 8th Wall.'
    >
      <BasicPageHeading>Contact us</BasicPageHeading>
      <section className='light'>
        <h2 className='text-center'>Get in touch with 8th Wall</h2>
        <div className={classes.hubspotForm}>
          <HubspotForm
            portalId='7182223'
            formId='478dd7d0-1b83-4429-acc7-19083a6ef219'
            loading={<div>Loading...</div>}
          />
        </div>
      </section>
    </Layout>
  )
}
